import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

const Why_Choose_Us_Frame = ({ className = "" }) => {
  const navigate = useNavigate();

  const onLearnMoreTextClick = useCallback(() => {
    navigate("/why-choose-us-learn-more-page");
  }, [navigate]);

  return (
    <div
      className={`bg-skyblue flex flex-col sm:flex-row box-border text-deepskyblue-200 font-istok-web p-8 gap-8 ${className}`}
    >
      <img
        className="relative rounded-2xl object-cover w-full sm:w-[350px] lg:w-[568px]"
        alt=""
        src="/presentation-pic@2x.png"
      />

      <div className="flex flex-col gap-8">
        <b className="uppercase text-21xl text-center">Why Choose Us</b>
        <b className="uppercase text-gray-100 text-10xl text-center">
          <p className="m-0">{`Why Choose Staffsurge Consultancy? `}</p>
        </b>
        <div className="text-11xl relative leading-[130%] text-gray-200 text-center [text-shadow:0px_4px_4px_rgba(0,_0,_0,_0)]">
          Choosing the right recruitment partner is crucial for the growth of
          business. Here's why StaffSurge Consultancy Pvt. Ltd. is the preferred
          choice for many organizations
        </div>
      </div>
    </div>
  );
};

Why_Choose_Us_Frame.propTypes = {
  className: PropTypes.string,
};

export default Why_Choose_Us_Frame;
